import React, { useState, useEffect } from "react"
import ReactDOM from "react-dom"
import MainWrapper from "../../helpers/MainWrapper"
import "./styles.less"
import CourierCard from "./components/CourierCard"
import { Row, Col } from "antd"
import { useMediaQuery } from "react-responsive"
import Request from "../../helpers/Request"

declare var root: any

const couriers = [
  {
    name: "UPS",
    url: "../terms_couriers_pages/ups-siuntos",
    logo: "ups.svg"
  },
  {
    name: "DPD",
    url: "../terms_couriers_pages/dpd-siuntos",
    logo: "dpd.svg"
  },
  {
    name: "DHL",
    url: "../terms_couriers_pages/dhl-siuntos",
    logo: "dhl.svg"
  },
  {
    name: "Omniva",
    url: "../terms_couriers_pages/omniva-siuntos",
    logo: "omniva.svg"
  },
  {
    name: "FedEx",
    url: "../terms_couriers_pages/fedex-siuntos",
    logo: "fedex.svg"
  },
  {
    name: "LPExpress",
    url: "../terms_couriers_pages/lp-express-siuntos",
    logo: "lpexpress.svg"
  },
  {
    name: "Lietuvos paštas",
    url: "../terms_couriers_pages/lietuvos-pastas-siuntos",
    logo: "lp.svg"
  },
  {
    name: "TNT",
    url: "../terms_couriers_pages/tnt-siuntos",
    logo: "tnt.svg"
  },
  {
    name: "GLS",
    url: "../terms_couriers_pages/gls-siuntos",
    logo: "gls.svg"
  },
  {
    name: "Post NL",
    url: "../terms_couriers_pages/post-nl-siuntos",
    logo: "postnl.svg"
  },
  {
    name: "Itella",
    url: "#",
    logo: "itella.svg"
  },
  {
    name: "Colis Prive",
    url: "#",
    logo: "colisprive.svg"
  },
  {
    name: "CTT",
    url: "#",
    logo: "ctt.svg"
  },
  {
    name: "BRT",
    url: "#",
    logo: "brt_logo.png"
  },
  {
    name: "Inpost",
    url: "#",
    logo: "inpost_logo.png"
  },
  {
    name: "Warenpost",
    url: "#",
    logo: "warenpost.svg"
  },
  {
    name: "Warenpost 2",
    url: "#",
    logo: "warenpost2.svg"
  },
  {
    name: "Austrian Post",
    url: "#",
    logo: "austrianpost.svg"
  }
]

const CouriersPage = () => {

  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [pageText, setPageText] = useState("")

  useEffect(() => {
    Request("/landing_page_info?identifier=couriers", "GET").then((response) => {
      setPageText(response.landing_page.body)
    })
  }, [])

  return (
    <>
      <MainWrapper menus={true}>
        <div style={{
          marginTop: isMobileScreen ? "30px" : "100px",
          textAlign: "center"
        }}>
          <h2 style={{
            fontSize: "39px",
            fontWeight: 700
          }}>
            Kurjeriai
          </h2>
        </div>
        <Row>
          <Col span={24} lg={{ offset: 2, span: 20 }}>
            <Row gutter={[16, 16]} style={{ height: "100%", paddingLeft: isMobileScreen ? 16 : 0, paddingRight: isMobileScreen ? 16 : 0 }}>
              {couriers.map((courier, index) => (
                <CourierCard key={index} {...courier} />
              ))}
              <Col>
                {pageText && (
                  <div dangerouslySetInnerHTML={{ __html: pageText }} />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </MainWrapper>
    </>
  )
}

if (root) {
  ReactDOM.render(<CouriersPage />, root)
}
